<template>
    <div id="app" style="background-color: #161a47;">
<!--        <router-view/>-->
        <router-view v-wechat-title="$route.meta.title" />
<!--        <HelloWorld/>-->
    </div>
</template>

<script>
  import HelloWorld   from '@/components/HelloWorld'
      export default {
          components:{
              HelloWorld
          },
          data() {
              return {
                  ruleForm: {

                  },
              };
          },
          methods: {

          }
      }
</script>
<style>
*{
    margin: 0px;
    padding: 0px;
}

html, body, #app {
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
    overflow: hidden;
}


li{list-style: none;}
.fl{float: left;}
.fr{float: right;}
.clear{clear: both;}
.text-left{text-align: left;}
.text-right{text-align: right;}
.text-center{text-align: center;}
i{font-style: normal;}
a{text-decoration: none;color: #333;}
a,.transition,button{transition: all 0.2s linear;-webkit-transition: all 0.2s linear;-moz-transition: all 0.2s linear;-ms-transition: all 0.2s linear;-o-transition: all 0.2s linear;}
input{outline: none;}
input:focus{outline:none;border: 0;}
.hide{display: none;}
input[type="button"], input[type="submit"], input[type="reset"] {
    　　-webkit-appearance: none;
}
textarea {
    　　-webkit-appearance: none;
}

.clearfix{
    clear: both;
}

#charts{
    padding: 3.667rem .833rem 0;
    color: #FFFFFF;
}

.overFixed{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
    height: 100%;
    /* background: url(./img/bg.png);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat; */
}

#header{
    /*background: url("./img/head.png") no-repeat;*/
    /*background-size: 100% 100%;*/
    /*height: 116px;*/
    text-align: center;
    margin: 0 0 1.2rem 0;
    position: relative;
}

#header #nowtime{
    display: inline-block;
    position: absolute;
    left: 36px;
    top: 36px;
    color: #AEE9FA;
    font-size: 20px;
}

#header span{
    color: #b2eeff;
    font-size: 1rem;
    position: absolute;
    left: 0;
    top: 72%;
    letter-spacing: 2px;
    right: 0;
}

.flexContainer {
    margin: 0 1.5rem;
}

.left_column{
    width: 420px;
    height: 914px;
    float: left;
    display: inline-block;
}

.left_column #top{
    width: 100%;
    /* height: 240px; */
    aspect-ratio: 517 / 284;
    background: url(./img/left_1.png) no-repeat;
    background-size: 100% 100%;
}

#top .content{
    width: 88%;
    margin: 0 auto;
    height: 162px;
    overflow: hidden;
    padding-top: 82px;
}


#top .content,#top .content p,#top .content span{
    color: #FFFFFF;
    font-size: 14px;
    line-height: 24px;
    text-align: justify;
}

.left_column #bottom{
    position: relative;
    width: 100%;
    height: 68vh;
    aspect-ratio: 519 / 607;
    overflow: hidden;
    margin-top: 2vh;
}

.left_column #bottom .bg {
    position: absolute;
    width: 100%;
    aspect-ratio: 519 / 750;
    background: url(./img/left_2.png) no-repeat;
    background-size: 100% 100%;
    z-index: 1;
}

.left_column #bottom .company_intro{
    width: 86%;
    margin: 0 auto;
}

.left_column #bottom strong{
    color: #FFFFFF;
    float: left;
    letter-spacing: 2px;
}

.left_column #bottom ul{
    position: relative;
    top: -4px;
    margin-left: 20px;
}

.left_column #bottom ul li{
    margin-left: 26px;
    font-size: 12px;
}

.left_column #bottom ul li span{
    font-size: 20px;
    margin-right: 3px;
}

.left_column #bottom ul,.left_column #bottom li{
    float: left;
    display: inline-block;
}

.center_column{
    width: 500px;
    /* aspect-ratio: 500 / 920; */
    height: 100%;
    float: left;
    display: inline-block;
    margin-left: 20px;
}
.flexContainer::after{
    content: '';
    display: block;
    clear: both;
}

.charts{
    width: 320px;
    height: 100px;
    display: inline-block;
    float: left;
    margin-top: -10px;
}
.map-location .el-icon-map-location{
    font-size: 24px;
    color: #6DF6FD;
}
.map-location .el-button span{
    font-size: 12px !important;
}
.map-location span{
    width: 300px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    margin: 0 8px;
    font-size: 16px;
    color: #FFFFFF;
}
.map-location{
    display: flex;
    margin-top: 15px;
}
.three_section .center-gray .green{
    color: #38EC91;
}
.three_section .center-gray .red{
    color: #FF2828;
}

#backhtml{
    position: absolute;
    right: 1%;
    top: 36px;
    color: #B1EDFE;
    font-size: 14px;
    border-bottom: 1px solid #B1EDFE;
    padding-bottom: 6px;
    z-index: 99;
    cursor: pointer;
}

#backhtml .el-icon-arrow-left{
    font-size: 18px;
    position: relative;
    top: 2px;
}
.three_section .center-gray .font{
    font-size: 26px;
    font-weight: bold;
}
.three_section .center-gray .text-font{
    font-size: 14px;
    color: #FFFFFF;
}
.three_section .img,.three_section .center-gray{
    width: 18%;
    display: inline-block;
    float: left;
    position: relative;
}
.three_section .center-gray{
    width: 22%;
}
.three_section .icon_img{
    position: absolute;
    top: 26%;
    left: 25%;
}
.three_section li .nowEcharts{
    position: absolute;
    right: -8%;
    top: 0;
}
.three_section li{
    margin-top: 16px;
    position: relative;
}

.three_section{
    width: 100%;
    clear: both;
    margin-top: -20px;
}
.user_section::after,.three_section li::after{
    content: '';
    display: block;
    clear: both;
}
.flex_gray .child{
    width: 150px;
}
.flex_gray .child::after{
    content: '';
    display: block;
    clear: both;
}
.process_cent span{
    color: #ffffff;
    font-size: 24px;
}
.process_cent  p{
    position: relative;
    top: -5px;
}
.process_cent {
    float: left;
    display: inline-block;
    margin-top: -6px;
    margin-left: 10px;
    text-align: center;
    font-size: 12px;
    color: #9BA2B4;
}
.process{
    width: 6px;
    display: inline-block;
    float: left;
    height: 34px;
    margin: 0 auto;
    background: #35FD85;
}

.process div{
    height: 34px;
    background: #B4B9BC;
}
.flex_gray{
    width: 70px;
    float: left;
    margin-left: 22px;
    margin-top: -3px;
    display: inline-block;
}
.user_section dl dd #shu{
    float: left;
    margin-left: 58px;
}
.user_section dl dd img{
    position: relative;
    top: 3px;
}
.user_section dl dd::after{
    content: '';
    display: block;
    clear: both;
}
.user_section dl dd #userimg{
    float: left;
    position: relative;
    top: -5px;
}
.user_section dl dd span{
    margin-right: 16px;
}
.user_section dl dd #grade{
    color: #ffffff;
    font-size: 18px;
    font-weight: 500;
    position: relative;
    top: 18px;
}
.user_section dl dd .user_grade{
    width: 120px;
    float: left;
    margin-left: 18px;
    font-size: 50px;
    color: #35fd85;
    display: inline-block;
}
.user_section dl dd{
    color: #e3f0ff;
    font-size: 12px;
    padding-left: 32px;
    line-height: 24px;
    margin: 8px 0;
    width: 100%;
}
.user_section dl dt img{
    position: relative;
    top: 6px;
    margin-right: 4px;
}
.user_section dl dt{
    font-size: 16px;
    color: #6df6fd;
    font-weight: bold;
}
.equipment{
    color: #e3f0ff;
    font-size: 18px;
    font-weight: bold;
    margin: 12px 0;
}
.right_container{
    width: 90%;
    margin: 0 auto;
    margin-top: 40px;
    position: relative;
}
.el-autocomplete{
    width: 100%;
}
::placeholder {
    text-align: center;
    color: #C3EFF2 !important;
}
.el-icon-search{
    font-size: 24px;
    position: absolute;
    top: 17px;
    left: 110px;
    color: #C3EFF2;
}
.right-center .el-input__inner{
    font-size: 16px;
    width: 100% !important;
    height: 58px;
    border: 0 !important;
    color: #C3EFF2 !important;
    background: #1F2755 !important;
}

.boxRadius{
    font-size: .25rem;
    width: 2.8rem;
    height: 1.4rem;
    line-height: 1.4rem;
    color: #081D42;
    text-align: center;
    border-radius: .25rem .65rem .65rem;
    display: inline-table;
}
.equipment .green{
    background-color: #02F5AD;
    font-size: 15px;
}
.equipment .error{
    background-color: #FE2828;
}
</style>



// WEBPACK FOOTER //
// src/App.vue